module.exports = __webpack_public_path__ + "img/logotipo-smartnotas.a5667250.svg";